import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { useBoolean } from "@/hooks/use-boolean";
import { useViewerHasAtLeastAdminRights } from "@/lib/rights/use-viewer-has-right";
import useAddExportModel from "@babackapp/private-api-client/client/use-add-export-method";
import useTranslation from "@babackapp/translations/use-translation";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@babackapp/ui/components/dialog";
import { Separator } from "@radix-ui/react-select";
import { PropsWithChildren } from "react";
import ExportSettingsForm, {
  ExportSettingsFormValues,
} from "./export-settings-form";

export default function AddExportSettingsDialog({
  children,
}: PropsWithChildren) {
  const t = useTranslation();
  const open = useBoolean();
  const { data: shop } = useCurrentShopSuspense();
  const hasAdminRights = useViewerHasAtLeastAdminRights();

  const { mutateAsync: addExport } = useAddExportModel(shop, {
    onSuccess: open.setFalse,
  });
  // const { mutateAsync: checkFTPLogin } = useCheckFTPLogin(shop);

  const onSubmit = ({
    server: { serverType, host, user, password, path },
    options: { modelId, cron, resolutions, statuses, locationIds, returnStoreIds },
  }: ExportSettingsFormValues) => {
    return addExport({
      shopExport: {
        cron,
        filter: {
          status: statuses,
          resolution: resolutions,
          locationIds,
          returnStoreIds,
        },
        type: serverType,
        exportModelId: modelId,
        login: {
          host,
          user,
          password,
          path,
        },
      },
    });
  };

  const onValidate = () => {
    // return checkFTPLogin({
    //   serverType: values.serverType,
    //   ftpLogin: {
    //     host: values.host,
    //     user: values.user,
    //     password: values.password,
    //     path: values.path,
    //   },
    //   sftpLogin: {
    //     host: values.host,
    //     user: values.user,
    //     password: values.password,
    //     path: values.path,
    //   },
    // });
  };

  if (!hasAdminRights) {
    return null;
  }

  return (
    <Dialog open={open.value} onOpenChange={open.setValue}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="pt-10">
        <DialogHeader>
          <DialogTitle>
            {t("settings.integrations.exports.addExport.title")}
          </DialogTitle>
          <DialogDescription>
            {t("settings.integrations.exports.addExport.description")}
          </DialogDescription>
        </DialogHeader>
        <Separator className="my-4" />
        <ExportSettingsForm onValidate={onValidate} onSubmit={onSubmit} />
      </DialogContent>
    </Dialog>
  );
}
